module.exports = __webpack_public_path__ + "img/foliomedian-logo.ebde82db.png";